import { render } from "./error-alert.component.vue?vue&type=template&id=569fb27a&ts=true"
import script from "./error-alert.component.vue?vue&type=script&lang=ts"
export * from "./error-alert.component.vue?vue&type=script&lang=ts"

import "./error-alert.component.vue?vue&type=style&index=0&id=569fb27a&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__